import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { KeycloakAuthService } from './auth.service';
import { ToastController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private keycloakAuthService: KeycloakAuthService,
    private router: Router,
    private toastController: ToastController
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.keycloakAuthService.authReady$.pipe(
      take(1), 
      map(isReady => {
        if (!isReady) {
          // Guardar la URL original para redireccionar después del login
          const returnUrl = route.url.join('/');
          if (returnUrl) {
            sessionStorage.setItem('returnUrl', '/' + returnUrl);
          }
          this.router.navigate(['/Login']);
          return false;
        }

        const isLoggedIn = this.keycloakAuthService.isLoggedIn();
        if (!isLoggedIn) {
          // Guardar la URL original para redireccionar después del login
          const returnUrl = route.url.join('/');
          if (returnUrl) {
            sessionStorage.setItem('returnUrl', '/' + returnUrl);
          }
          this.presentToast('Debes iniciar sesión para acceder', 'warning');
          this.router.navigate(['/Login']);
          return false;
        }

        const requiredGroups = route.data['requiredGroups'] || [];
        if (requiredGroups.length === 0) {
          return true; 
        }

        const userGroups = this.keycloakAuthService.getUserGroups() || [];
        if (userGroups.includes('grpGeddisAdmin')) {
          return true;
        }

        const hasPermission = requiredGroups.some((group: string) => userGroups.includes(group));
        if (!hasPermission) {
          this.presentToast('No tienes permisos para acceder a esta sección.', 'danger');
          this.router.navigate(['/Home']);
        }
        
        return hasPermission;
      })
    );
  }

  private async presentToast(message: string, color: string = 'primary') {
    const toast = await this.toastController.create({
      message,
      duration: 2500,
      color,
      position: 'bottom',
    });
    toast.present();
  }
}